import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Factory, Cog, BarChart3, Shield } from 'lucide-react';

const ManufacturingServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Manufacturing & Industry 4.0 Solutions | AuVSys</title>
        <meta name="description" content="Transform your manufacturing operations with Industry 4.0 solutions, IoT integration, and smart factory technologies." />
      </Helmet>

      <div className="manufacturing-services">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Manufacturing & Industry 4.0</h1>
              <p>Transform your manufacturing operations with cutting-edge Industry 4.0 solutions, IoT integration, and smart factory technologies that drive efficiency and innovation.</p>
            </div>
          </div>
        </section>

        <section className="services-grid">
          <div className="container">
            <div className="grid">
              <div className="service-card">
                <Factory className="service-icon" />
                <h3>Smart Factory Solutions</h3>
                <p>IoT-enabled manufacturing systems with real-time monitoring and predictive maintenance.</p>
              </div>
              <div className="service-card">
                <Cog className="service-icon" />
                <h3>Process Automation</h3>
                <p>Automated production lines with AI-driven quality control and optimization.</p>
              </div>
              <div className="service-card">
                <BarChart3 className="service-icon" />
                <h3>Supply Chain Analytics</h3>
                <p>End-to-end visibility and optimization of your manufacturing supply chain.</p>
              </div>
              <div className="service-card">
                <Shield className="service-icon" />
                <h3>Industrial Cybersecurity</h3>
                <p>Secure your manufacturing systems against cyber threats and ensure compliance.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ManufacturingServices;